import React from "react"

import MaterialReactTable, { MRT_ColumnDef } from "material-react-table"

import { SubscriptionTableState, SubscriptionTableProps } from "./models"

import {
    IconButton,
    Stack,
    Box
} from "@mui/material"

import EditIcon from "@mui/icons-material/Edit"
import DeleteIcon from "@mui/icons-material/Delete"

import { t } from "@lingui/macro"
import {RouteComponentProps, withRouter} from "react-router-dom";
import { ConfirmModal } from "commons/modal/confirm-modal"


class SubscriptionTable extends React.Component<SubscriptionTableProps & RouteComponentProps<any>, SubscriptionTableState>
{

    private tableColumns: MRT_ColumnDef[];

    public constructor(props: any) {

        super(props)

        this.state={
            openConfirmModal: false,
            subscriptionToDelete: ""
        }

        this.tableColumns = [
            {
                header: t({
                    id: "st-table-col-name",
                    message: "Nome"
                }),
                accessorKey: "name",
            },
            {
                header: t({
                    id: "st-table-col-monthly-price",
                    message: "Prezzo mensile"
                }),
                accessorKey: "monthlyPriceWithoutVAT",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<number>()/100} €
                        </Box>
                    );
                },
            },
            {
                header: t({
                    id: "st-table-col-yearly-price",
                    message: "Prezzo annuale"
                }),
                accessorKey: "yearlyPriceWithoutVAT",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<number>()/100} €
                        </Box>
                    );
                },
            },
            {
                header: t({
                    id: "st-table-col-vat",
                    message: "IVA"
                }),
                accessorKey: "VATPercentage",
                Cell: ({ cell }) => {
                    return (
                        <Box>
                            {cell.getValue<number>()} %
                        </Box>
                    );
                },
            },
        ];
    }

    private openConfirmModal = (id: string) : void =>{
        this.setState(() => ({
            openConfirmModal: true,
            subscriptionToDelete: id
        }))
    }

    private cancelConfirmModalCallback = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
            subscriptionToDelete: ""
        }))
    }

    private acceptConfirmModal = () : void =>{
        this.setState(() => ({
            openConfirmModal: false,
        }))
        this.deleteContentList()
    }

    private deleteContentList = (): void => {
        this.props.deleteSubscription(this.state.subscriptionToDelete);
        this.setState(() => ({
            subscriptionToDelete: ""
        }))

    }

    private getIdValue = (row: any): string => {
        return row.original.id
    }


    private handlePageChange = (updateFn: any) => {
        let newPagination = updateFn(this.props.pagination);
        this.props.updatePaginationCallBackFn(newPagination);
    }

    private goEdit = (row: any): void => {
        let { history } = this.props
        history.push(`/backoffice/edit-subscription/${this.getIdValue(row)}`);
    }

    render() {
        return (<>
            <Box style={{ maxWidth: '100%' }}>
                <MaterialReactTable
                    columns={this.tableColumns}
                    rowCount={this.props.totalSubscriptionsCount}
                    data={this.props.subscriptions}
                    enableRowSelection={false}
                    enableColumnOrdering
                    enableGlobalFilter={false}
                    enableFilters={false}
                    muiTableHeadCellProps={{
                        sx: {
                            color: "white",
                            backgroundColor: process.env.REACT_APP_PRIMARY_COLOR
                        }
                    }}
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            header: ""
                        },
                    }}
                    enableRowActions
                    positionActionsColumn="last"
                    renderRowActions={({ row }) => (
                        <Stack direction={"row"} display={"flex"} justifyContent={"right"} >
                            <IconButton onClick={() => this.goEdit(row)}>
                                <EditIcon />
                            </IconButton>
                            <IconButton onClick={() => this.openConfirmModal(this.getIdValue(row))}>
                                <DeleteIcon />
                            </IconButton>
                        </Stack>
                    )}
                    onPaginationChange={this.handlePageChange}
                    enableTopToolbar={false}
                    manualPagination={true}
                    enableDensityToggle={false}
                    state={{ pagination: this.props.pagination }}
                    initialState={{ pagination: this.props.pagination }} />
            </Box>
            {this.state.openConfirmModal && <ConfirmModal
                cancelConfirmCallback={this.cancelConfirmModalCallback}
                confirmCallback={this.acceptConfirmModal}
                text={"Sei sicuro di voler procedere con l'eliminazione dell'abbonamento?"}
                textId={"st-delete-subscription-text"}
            />}
        </>)
    }
}

export default withRouter(SubscriptionTable);